import { render, staticRenderFns } from "./manuallycreate.vue?vue&type=template&id=1e67693c&scoped=true&"
import script from "./manuallycreate.vue?vue&type=script&lang=js&"
export * from "./manuallycreate.vue?vue&type=script&lang=js&"
import style0 from "./manuallycreate.vue?vue&type=style&index=0&id=1e67693c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e67693c",
  null
  
)

export default component.exports